<li *ngIf="ttHasDivider" class="tt-overflow-item tt-overflow-item__seperator" role="separator"></li>
<li [attr.id]="id.button" class="tt-overflow-item">
    <button
        [title]="tooltipText"
        [ngClass]="{ 'tt-overflow-item__button--danger': ttDanger }"
        class="tt-overflow-item__button"
        (click)="click($event)"
        [ngStyle]="style['button']"
        [disabled]="ttDisabled || false"
    >
        <span *ngIf="!!text">{{ text }}</span>
        <ng-content></ng-content>
        <span *ngIf="icon" [ngClass]="icon" class="fa-fw"></span>
    </button>
</li>
